import { usePage } from "@inertiajs/react"
import { StaffManageUserForm } from "@/components/features/staff/manage-users/user-form"
import { StaffLayout } from "@/components/layouts/staff-layout"
import { t } from "@/lib/i18n"
type RoleOption = {
    value: string
    label: string
}
type FormUser = {
    id?: number
    userId?: number
    name?: string
    emailAddress?: string
    role?: string
}
export default function StaffLocationManageUsersEdit() {
    const { roleOptions, user } = usePage<{
        roleOptions: RoleOption[]
        user: FormUser
    }>().props
    return (<StaffLayout>
      <StaffManageUserForm mode="edit" title={t("ui.react.pages.staff.location.manage.users.edit.edit_staff_member")} description={t("ui.react.pages.staff.location.manage.users.edit.update_identity_role_credentials_staff")} roleOptions={roleOptions} user={user}/>
    </StaffLayout>)
}
